import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Spinner from 'react-bootstrap/Spinner';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import { useNavigate, Link } from "react-router-dom";

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL + '/materialanforderungen'; 
const API_KEY = process.env.REACT_APP_BACKEND_API_KEY; 

const InterneMaterialanforderung = () => {  
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [daten, setDaten] = useState([]);
  const [filterState, setFilterState] = useState("offen");

  // FetchData ist jetzt flexibel und steuert das Loading sauber
  const fetchData = useCallback(async (filter) => {
    setLoading(true);
    try {
      const url = filter === "offen" 
        ? `${BACKEND_BASE_URL}/offene-interne` 
        : `${BACKEND_BASE_URL}`;

      const res = await axios.get(url, {
        headers: {
          'x-api-key': API_KEY
        }
      });

      setDaten(res.data || []);
      console.log("API aufgerufen:", url);
    } catch (err) {
      console.error("Fehler beim Laden der Materialanforderungen:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // EIN EINZIGER HOOK: Kümmert sich um Login-Schutz UND lädt die Daten neu, wenn sich der Filter ändert
  useEffect(() => {
    if (localStorage.getItem("loginData") == null) {
      navigate("/dhworld/login");
      return;
    }
    
    fetchData(filterState);
  }, [filterState, navigate, fetchData]);

  const getCardStyle = (isActive) => ({
    border: isActive ? '3px solid #28a745' : '2px solid transparent',
    borderRadius: '10px',
    textAlign: 'center',
    padding: '20px',
    backgroundColor: isActive ? '#e8f5e9' : '#ffffff',
    boxShadow: isActive ? '0 0 10px rgba(40,167,69,0.4)' : 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  });

  return (
    <div style={{ backgroundColor: '#eceff2', minHeight: '100vh' }} className="container-fluid">
      <div className="row pt-4">
        <div className='col-12'>
          <Link to="/insight">
            <i style={{ fontSize: '25px', color: '#333' }} className="bi bi-arrow-return-left"></i>
          </Link>
          <br /><br />
          <h1>Materialanforderung auswählen</h1>
        </div>
      </div>

      {/* --- Umschaltbereich (Karten-Filter) --- */}
      <div className="row pt-4 text-center justify-content-center">
        <div className="col-6 col-md-3" onClick={() => setFilterState("alle")}>
          <div style={getCardStyle(filterState === "alle")}>
            <i className="bi bi-archive" style={{ fontSize: '30px', color: '#28a745' }}></i>
            <div style={{ marginTop: '8px', fontWeight: 600 }}>Alle Anforderungen</div>
          </div>
        </div>

        <div className="col-6 col-md-3" onClick={() => setFilterState("offen")}>
          <div style={getCardStyle(filterState === "offen")}>
            <i className="bi bi-archive-fill" style={{ fontSize: '30px', color: '#28a745' }}></i>
            <div style={{ marginTop: '8px', fontWeight: 600 }}>Offene Interne Materialanforderungen</div>
          </div>
        </div>
      </div>

      <br /><br />

      {loading ? (
        <Row>
          <Col xs={12} className="text-center">
            <Spinner animation="border" variant="success" />
          </Col>
        </Row>
      ) : (
        <Row className="g-4">
          {daten && daten.length > 0 ? (
            /* WICHTIG: "striped" entfernt, damit deine Zeilenfarben funktionieren! bg="white" zu className geändert */
            <Table responsive bordered hover className="bg-white">
              <thead>
                <tr>
                  <th>Vorgangs-ID</th>
                  <th>KDI-Nr</th>
                  <th>Straße</th>
                  <th>Monteur</th>
                  <th>Vorgangsdatum</th>
                  <th>Artikel (Anzahl)</th>
                  <th>Lager Status</th>
                  <th>Gesamt Status</th>
                </tr>
              </thead>
                <tbody>
                {daten.map((v, index) => {
                  let rowStyle = {};
                  if (v.vorgangAbgeschlossen) {
                    rowStyle = { backgroundColor: '#d4edda' }; // Grün
                  } else if (v.lagerAbgeschlossen) {
                    rowStyle = { backgroundColor: '#fff3cd' }; // Gelb
                  } else {
                    rowStyle = { backgroundColor: '#ffffff' }; // Weiß
                  }

                  return (
                    <tr
                      key={index}
                      onClick={() => {
                        if (!v.vorgangsId || v.vorgangsId === "") {
                          alert("Fehler: VorgangsID fehlt.");
                          return;
                        }

                        const isBearbeitenModus = filterState === "offen";

                        navigate(
                          `/materialanforderung-position/${encodeURIComponent(v.id)}`,
                          {
                            state: {
                              vorgangsId: v.vorgangsId,
                              kdiNr: v.kdiNr,
                              monteur: v.vorgangsMonteur,
                              artikelListe: v.artikel,
                              strasse: v.strasse,
                              vorgangszeitpunkt: v.vorgangszeitpunkt,
                              bearbeiten: isBearbeitenModus
                            }
                          } 
                        );
                      }}
                      style={{ cursor: 'pointer', ...rowStyle }}
                    >
                      <td><strong>{v.vorgangsId}</strong></td>
                      <td>{v.kdiNr}</td>
                      <td>{v.strasse}</td>
                      <td>{v.vorgangsMonteur}</td>
                      <td>{v.vorgangszeitpunkt ? new Date(v.vorgangszeitpunkt).toLocaleString('de-DE') : '-'}</td>
                      <td>
                        <span className="badge bg-secondary">
                          {v.artikel ? v.artikel.length : 0} Position(en)
                        </span>
                      </td>
                      <td>{v.lagerAbgeschlossen ? "✔️ Erledigt" : "⏳ Offen"}</td>
                      <td>{v.vorgangAbgeschlossen ? "🔒 Beendet" : "🔄 Aktiv"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          ) : (
            <Col xs={12}>
              <div
                style={{
                  background: '#fff',
                  padding: '1rem',
                  borderRadius: '8px',
                  textAlign: 'center'
                }}
              >
                Keine Materialanforderungen gefunden
              </div>
            </Col>
          )}
        </Row>
      )}
    </div>
  );
};

export default InterneMaterialanforderung;